<template>
    <div class="clearfix main_center" >
        <div class="top-content">
            <div class="left-navbar">
                <el-button size="small" @click="backBtn">返回</el-button>
                <el-button type="primary" size="small" plain style="margin-right:10px;"
                           v-if="hasBtnPermission('btn_jz_pm_dgwitness_guard_config_add')"
                           @click="routerEdit()">编辑</el-button>
                
            </div>
        </div>
        <div class="right-content">
            <el-form ref="form" :model="form" label-width="150px" class="form viewFormWrapper">
                <el-card class="box-card" style="margin-bottom: 0px" :style="{'height':cardHight}" >
                    <div slot="header" class="clearfix">
                        <span>配置信息</span>
                    </div>
                    <el-row>
                        <el-col :span="12">
                            <el-form-item label="名称：">
                                <span>{{form.name }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="流id：">
                                <span>{{form.streamId }}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="12">
                             <el-form-item label="流媒体地址：">
                                <span>{{form.streamUrl }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                             <el-form-item label="所在楼层：">
                                <span>{{form.locationName }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="所属交易中心：">
                                <span>{{form.tradeOrgName }}</span>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="发布标记：" >
                               <span>{{form.pubFlag==0?"未发布":"已发布"}}</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-card>
            </el-form>
        </div>
        

    </div>
</template>

<script>

    import {mapState} from "vuex";
    // import {tabsCloseCurrentHandle} from '@/utils/routeTab';

    export default {
     components: {

    },
    data(){     
        return{
            cardHight:(document.documentElement.clientHeight - 184) + 'px',
            form:{
              name: '',//名称
              streamId: '', //流id
              streamUrl: '',//流媒体地址
              pubFlag: '',//发布标记 1已发布 0未发布
            },
            id:'', //点击提交的时候也传id
        }
    },
    computed: {
        ...mapState({
                stateData:state=>state.user
        })
    },
    activated(){

        this.id = window.sessionStorage.getItem("id")
        this.getDataById()

    },
    methods:{
        backBtn(){ //返回
          tabsCloseCurrentHandle();
          this.$router.push({
                name:'guard_config_list'
            })
            this.$refs.form.resetFields();
        },
        routerEdit(){
            this.$router.push({
                name:'guard_config_detail'
            })
        },
        getDataById(){ //详情

            if(this.id != ""){

                this.$httpReq.get('/sysGuardConfig/get?id='+this.id).then(res=>{
                    if(res.data.code == '1'){
                        this.id = res.data.data.id
                        const data = res.data.data
                        this.form={
                            id:this.id,
                          name: data.name,//名称
                          streamId: data.streamId, //流id
                          streamUrl:data.streamUrl,//流媒体地址
                          pubFlag: data.pubFlag,//发布标记 1已发布 0未发布
                            location:data.location,
                            locationName:data.locationName,
                            tradeOrgName:data.tradeOrgName,
                        }
                    }
                })

            }
        },

    }



}
</script>

<style lang="scss" scoped>

</style>